module.exports = __webpack_public_path__ + "e1ae2818dfb8e51b7ab3d351fd41951e.jpg";